import { render, staticRenderFns } from "./SpinnerText.vue?vue&type=template&id=26ac99e2"
import script from "./SpinnerText.vue?vue&type=script&lang=js"
export * from "./SpinnerText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports